import { makeNumberSchema, makeStrictNumberSchema } from '../general/number.ts';

const MIN = 1;
const MAX = 255;

const minMessage = `Routines must be at least ${MIN.toLocaleString()}`;
const maxMessage = `Routines can be at most ${MAX.toLocaleString()}`;
const requiredMessage = `Choose a number from ${MIN.toLocaleString()} to ${MAX.toLocaleString()}`;

export const routinesSchema = makeNumberSchema({
  min: { value: MIN, message: minMessage },
  max: { value: MAX, message: maxMessage },
});

export const routinesRequiredSchema = routinesSchema.refine((val): val is number => val !== null, {
  message: requiredMessage,
});

export const routinesStrictSchema = makeStrictNumberSchema({
  min: { value: MIN, message: minMessage },
  max: { value: MAX, message: maxMessage },
  required: { message: requiredMessage },
});
